import { render, staticRenderFns } from "./ExpAbout.vue?vue&type=template&id=144c40e4"
import script from "./ExpAbout.vue?vue&type=script&lang=js"
export * from "./ExpAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports